<div class="val-flex-conteneur val-flex-colonne" style="height: 100%; overflow: hidden;">
  <div class="val-flex-1" style="overflow: hidden;">
    <router-outlet></router-outlet>
  </div>
</div>